/* eslint-disable no-param-reassign */
export default (state, { payload }) => {
  state.streams.loading = false;
  state.streams.isLastPage = payload.last;
  state.streams.list ??= {};

  const newStreams = Object.fromEntries(payload.content.map((item) => [item.id, item]));
  Object.assign(state.streams.list, newStreams);
};
